import { expVal } from '@atlassian/jira-feature-experiments';

const AssignMultiAgentsBoardM2DndRelayProvider = {
	get(): boolean {
		return expVal('assign-multi-agents-board-m2-dnd-technical-gate', 'isEnabled', false);
	},
};

export default AssignMultiAgentsBoardM2DndRelayProvider;
